import { fetchIndexHealthSampleRequest } from 'actions/customers';
import { API, Selector } from 'types';

export const getIndexHealthSample: Selector<API.Customers.IndexHealthSample | null> = (state) =>
  state.customers.indexHealthSample;

export const getIndexHealthSampleLoading: Selector<boolean> = (state) =>
  state.customers.loading.includes(fetchIndexHealthSampleRequest.toString());
